<template>
  <div class="nvt_box" :class="{ 'scrolled': scrollTop > 50 }">
    <div class="H_da" role="navigation" aria-label="主导航">
      <router-link class="logo_img" role="link" tabindex="0" to="/">
        <img src="../../assets/image/logo.png" alt="中青网音乐动漫 Logo" />
      </router-link>

      <ul class="nav-list" role="menubar">
        <li role="none"><router-link to="/" role="menuitem">首页</router-link></li>
        <li role="none"><router-link to="/sucai" role="menuitem">中青音工坊</router-link></li>
        <li role="none"><router-link to="/manhua" role="menuitem">中青漫画</router-link></li>
        <!-- <li role="none"><router-link to="/collection" role="menuitem">精选合集</router-link></li> -->
      </ul>

      <div class="action-group">
        <div class="wcnrbh" role="search" @click="Wicheng()">
          <span :style="{color:isWcnrEnabled=='true'?'#58d100':'#fff'}">青少年模式</span>
        </div>
        <div class="search" role="search" @click="$router.push('/topUp')">
          <span>充值</span>
          <img src="../../assets/image/qiandai.png" alt="">
        </div>

        <div class="auth">
          <router-link v-show="$store.state.dlMark == null" to="/login">登录 / 注册</router-link>
          <router-link class="gr" v-show="$store.state.dlMark !== null" to="/personal">
            <img :src="$store.state.dlMark !== null ? $store.state.dlMark.touxiang : '#'" alt="">
            <p>{{ $store.state.dlMark !== null ? $store.state.dlMark.nicheng : '' }}</p>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 1. 未成年人保护弹窗遮罩层 -->
    <div class="wcnr-modal-mask" v-show="isWcnrModalShow" @click="closeWcnrModal"></div>
    <!-- 2. 弹窗主体 -->
    <div class="wcnr-modal" v-show="isWcnrModalShow">
      <div class="wcnr-modal-header">
        <h3>青少年保护模式</h3>
        <button class="wcnr-modal-close" @click="closeWcnrModal">&times;</button>
      </div>
      <div class="wcnr-modal-body">
        <p>开启后将自动过滤不适宜未成年人的内容，限制付费充值与浏览时长</p>
        <p>为未成年人营造健康的上网环境。</p>
        <p class="wcnr-notice">💡 开启后可在导航栏中的青少年模式中关闭</p>
      </div>
      <div class="wcnr-modal-footer">
        <button class="wcnr-btn cancel" @click="closeWcnrModal">取消</button>
        <button class="wcnr-btn confirm" @click="enableWcnrMode">确认开启</button>
      </div>
    </div>

  </div>
</template>

<script>
import logoImg from '../../assets/logo.png'

export default {
  name: 'Nheader',
  data() {
    return {
      logo: logoImg,
      keyword: '',
      scrollTop: 0,
      isWcnrModalShow: false, // 控制弹窗显示/隐藏
      isWcnrEnabled: localStorage.getItem('isWcnrEnabled') === 'flase' // 持久化保护模式状态
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 兼容不同浏览器的滚动高度获取方式
      this.scrollTop =
        window.scrollY ||  // 现代浏览器
        document.documentElement.scrollTop ||  // IE/Edge
        document.body.scrollTop  // 旧版浏览器
    },
    // 点击"未成年人保护"触发（区分开启/关闭逻辑）
    Wicheng() {
      if (this.isWcnrEnabled) {
        // 已开启：提示是否关闭
        this.$confirm('当前已开启未成年人保护模式，关闭后将恢复全部功能', '提示', {
          confirmButtonText: '确认关闭',
          cancelButtonText: '取消',
          type: 'warning',
          background: '#1a1f2c',
          color: '#fff'
        }).then(() => {
          this.isWcnrEnabled = false;
          localStorage.setItem('isWcnrEnabled', 'false'); // 持久化关闭状态
          this.$message.success('保护模式已关闭');
        }).catch(() => {
          this.$message.info('已取消关闭');
        });
      } else {
        // 未开启：打开弹窗
        this.isWcnrModalShow = true;
      }
    },
     // 关闭弹窗
    closeWcnrModal() {
      this.isWcnrModalShow = false;
    },
    // 开启保护模式
    enableWcnrMode() {
      this.isWcnrEnabled = true;
      localStorage.setItem('isWcnrEnabled', 'true'); // 持久化开启状态（刷新页面不失效）
      this.closeWcnrModal();
      this.$message.success('未成年人保护模式已开启！');
      
      // （可选）这里可以添加保护模式的核心逻辑，比如：
      // 1. 跳转家长验证页面
      // 2. 限制某些路由访问
      // 3. 过滤不良内容等
    }
  }
}
</script>

<style scoped lang="scss">
.wcnrbh {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 50px;
  font-size: 15px;
  color: #f2f2f2;
  text-shadow: 0 0 12px #ffffff;
  transition: 0.2s;
}


.wcnrbh:hover {
  color: rgb(255, 255, 255);
  transform: 0.2s;

  box-shadow: 0 0 12px rgb(255, 255, 255);
}

/* 未成年人保护弹窗样式 */
.wcnr-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1001; // 高于导航栏z-index=1000
  transition: opacity 0.3s;
}

.wcnr-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  background: #1a1f2c; // 与页面深色风格一致
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1002;
  color: #ffffff;
  overflow: hidden;
}

.wcnr-modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #2d3446;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  .wcnr-modal-close {
    background: transparent;
    border: none;
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s;

    &:hover {
      color: #ff7e5f; // 与充值按钮渐变色呼应
    }
  }
}

.wcnr-modal-body {
  padding: 20px;
  line-height: 1.8;

  p {
    margin: 0 0 10px;
    font-size: 14px;
    color: #e0e0e0;
  }

  .wcnr-notice {
    color: #a0a0a0;
    font-size: 13px;
    margin-top: 15px;
  }
}

.wcnr-modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #2d3446;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.wcnr-btn {
  padding: 10px 22px;
  border-radius: 50px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &.cancel {
    background: #2d3446;
    color: #e0e0e0;

    &:hover {
      background: #3d4759;
    }
  }

  &.confirm {
    background-image: linear-gradient(90deg, #ff7e5f, #d5874c); // 与充值按钮同渐变
    color: #ffffff;

    &:hover {
      box-shadow: 0 0 12px 0 #ffaf9b; // hover发光效果
    }
  }
}

.scrolled {
  width: 100%;
  background-color: #0f1723;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  position: fixed;
  z-index: 1000;
  transition: 0.3s;
}

.nvt_box {
  width: 100%;
  position: fixed;
  z-index: 1000;
  background-color: transparent; // 修复原代码"none"错误
  transition: 0.3s;

  .H_da {
    max-width: 1300px;
    height: 64px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;

    .logo_img {
      display: flex;
      align-items: center;
      cursor: pointer;

      img {
        height: 55px;
        margin-right: 8px;
      }

      .site-name {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
      }
    }

    .nav-list {
      display: flex;
      list-style: none;
      gap: 20px;

      li a {
        color: #ffffff;
        text-decoration: none;
        font-size: 16px;
        padding: 8px 15px;
        border-radius: 50px;
        transition: 0.2s;
        text-shadow: 0 0 12px #ffffff;
      }

      li a:hover {
        color: rgb(255, 255, 255);
        transform: 0.2s;
        box-shadow: 0 0 12px rgb(255, 255, 255);
      }
    }

    .action-group {
      display: flex;
      align-items: center;
      gap: 12px;

      .search {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 10px 16px;
        border-radius: 50px;
        background-image: linear-gradient(90deg, #ff7e5f, #d5874c);
        font-size: 15px;
        color: #f2f2f2;

        img {
          width: 20px;
          height: 20px;
          margin-left: 5px;
        }
      }

      .search:hover {
        box-shadow: 0 0 12px 0 #ffaf9b;
        transition: 0.3s;
        color: #ffffff;
      }

      .auth a {
        padding: 10px 16px;
        color: #000000;
        border-radius: 50px;
        background: #ffffff;
        font-size: 15px;
        text-decoration: none;
        cursor: pointer;
        transition: 0.3s;
      }

      .auth a:hover {
        color: #d74902;
        transition: 0.3s;
        box-shadow: 0 0 12px 0 #ffffff;
      }

      .auth>.gr {
        background: none;
        display: flex;
        align-items: center;
        color: #ffffff;

        img {
          width: 35px;
          height: 35px;
          object-fit: cover;
          border-radius: 50px;
          margin-right: 5px;
        }
      }

      .auth>.gr:hover {
        box-shadow: none;
        color: #ffffff;
        text-shadow: 0 10px 15px #fff;
      }
    }
  }
}

/* 响应式处理 */
@media (max-width: 900px) {
  .H_da {
    .nav-list {
      display: none;
    }

    .search input {
      width: 120px;
    }
  }

  /* 弹窗响应式调整 */
  .wcnr-modal {
    width: 95%;
    padding: 0 5px;
  }

  .wcnr-modal-body {
    padding: 15px;
  }

  .wcnr-modal-footer {
    padding: 12px 15px;
    flex-wrap: wrap;
  }

  .wcnr-btn {
    padding: 8px 16px;
  }
}
//结束

.scrolled {
  width: 100%;
  background-color: #0f1723;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  position: fixed;
  z-index: 1000;
  transition: 0.3s;
}

.nvt_box {
  width: 100%;
  position: fixed;
  z-index: 1000;
  background-color: none;
  transition: 0.3s;

  .H_da {
    max-width: 1300px;
    height: 64px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;

    .logo_img {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 300px;
      img {
        height: 55px;
        margin-right: 8px;
      }

      .site-name {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
      }
    }

    .nav-list {
      display: flex;
      list-style: none;
      gap: 20px;

      li a {
        color: #ffffff;
        text-decoration: none;
        font-size: 16px;
        padding: 8px 15px;
        border-radius: 50px;
        transition: 0.2s;

        text-shadow: 0 0 12px #ffffff;
      }

      li a:hover {
        color: rgb(255, 255, 255);
        transform: 0.2s;

        box-shadow: 0 0 12px rgb(255, 255, 255);
      }
    }

    .action-group {
      display: flex;
      align-items: center;
      gap: 12px;

      .search {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 10px 16px;
        border-radius: 50px;
        background-image: linear-gradient(90deg, #ff7e5f, #d5874c);
        font-size: 15px;
        color: #f2f2f2;

        img {
          width: 20px;
          height: 20px;
          margin-left: 5px;
        }
      }

      .search:hover {
        box-shadow: 0 0 12px 0 #ffaf9b;
        transition: 0.3s;
        color: #ffffff;
      }

      .auth a {
        padding: 10px 16px;
        color: #000000;
        border-radius: 50px;
        background: #ffffff;
        font-size: 15px;
        text-decoration: none;
        cursor: pointer;
        transition: 0.3s;

      }

      .auth a:hover {
        color: #d74902;
        transition: 0.3s;
        box-shadow: 0 0 12px 0 #ffffff;
      }

      .auth>.gr {
        background: none;
        display: flex;
        align-items: center;
        color: #ffffff;

        img {
          width: 35px;
          height: 35px;
          object-fit: cover;
          border-radius: 50px;
          margin-right: 5px;
        }
      }

      .auth>.gr:hover {
        box-shadow: none;
        color: #ffffff;
        text-shadow: 0 10px 15px #fff;
      }
    }
  }
}

/* 响应式处理 */
@media (max-width: 900px) {
  .H_da {
    .nav-list {
      display: none;
    }

    .search input {
      width: 120px;
    }
  }
}
</style>